import { useEffect, useState } from 'react';

/** Breakpoint móvil consistente con AnimalList (< 640px). */
export const MOBILE_BREAKPOINT = 640;

/** Helper puro: true si el ancho corresponde a móvil. */
export function isMobileWidth(width: number): boolean {
  return width < MOBILE_BREAKPOINT;
}

/**
 * Hook reusable para detectar móvil según el ancho de ventana.
 * Reemplaza la lógica inline que vivía en AnimalList.tsx.
 */
export function useIsMobile(): { isMobile: boolean; width: number } {
  const [width, setWidth] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerWidth : MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return { isMobile: isMobileWidth(width), width };
}
